import { createContext, useContext, type CSSProperties } from 'react'

/**
 * Fundo do quadro Kanban estendido para o shell.
 *
 * O quadro publica o fundo escolhido (cor/gradiente/imagem) e o shell pinta o
 * `shell__main` inteiro — barra superior (com pelicula escura por cima) e
 * painel explorer (translucido) inclusos — como no Trello.
 */
export type BoardBackground = {
  style: CSSProperties
  /** Fundo escuro -> textos claros nas areas pintadas. */
  dark: boolean
}

export const BoardBackgroundContext = createContext<(bg: BoardBackground | null) => void>(() => {})

export function useSetBoardBackground() {
  return useContext(BoardBackgroundContext)
}

/**
 * Tela cheia do quadro (SPEC-20260915-2116): o quadro pede ao shell para
 * esconder rail, explorer e alças — a mesma "tela cheia" das aplicações — e
 * ocupa a janela inteira com a própria barra de ferramentas no topo.
 */
export const BoardTelaCheiaContext = createContext<(cheia: boolean) => void>(() => {})

export function useSetBoardTelaCheia() {
  return useContext(BoardTelaCheiaContext)
}
